<template>
  <!-- Toggle Sidebar Button -->
  <div>
    <div class="mobile-toggle-button-wrapper">
      <div class="mobile-toggle-button" @click="toggleSidebar">
        <i class="fas fa-chevron-right icon-style fa-lg" style="margin-bottom: 30px;"></i>
      </div>
    </div>

    <!-- Profile Sidebar -->
    <div class="profile-sidebar" :class="{ open: isSidebarOpen }">
      <div class="widget-profile pro-widget-content" style="border: none; background-color: #f8f8f8; margin: 0;">
        <div class="profile-info-widget">
          <router-link to="/doctor/profile-settings" class="booking-doc-img">
            <img v-bind:src="config.base_url_for_Image + hospitalImage" alt="User Image" />
          </router-link>
          <div class="profile-det-info">
            <h3>{{ this.hospitalName }}</h3>
          </div>

          <div class="profile-det-info">
            <h3>{{ this.hospitalCity }}</h3>
          </div>
        </div>
      </div>
      <div class="dashboard-widget" style=" background-color: #f8f8f8;">
        <nav class="dashboard-menu">
          <ul>
            <li :class="currentPath == 'on-boarding' ? 'active' : 'notaactive'
            ">
            <router-link to="/hospital/on-boarding">
              <i class="fas fa-tasks"></i>
              <span>Onboarding</span>
            </router-link>
          </li>
            <li :class="currentPath == 'hospital-appointment' ? 'active' : 'notactive'
              ">
              <router-link to="/hospital/appointment">
                <i class="fas fa-calendar-check"></i>
                <span>Appointment</span>
              </router-link>
            </li>
            <li :class="currentPath == 'doctor' ? 'active' : 'notactive'
              ">
              <router-link to="/hospital/doctor">
                <i class="fas fa-user-md"></i>
                <span>Doctor</span>
              </router-link>
            </li>
            <li :class="currentPath == 'patient' ? 'active' : 'notactive'">
              <router-link to="/hospital/patient">
                <i class="fas fa-user-injured"></i>
                <span>Patient</span>
              </router-link>
            </li>
            <li :class="currentPath == 'hospital-encounter' ? 'active' : 'notactive'">
              <router-link to="/hospital/hospital-encounter">
                <i class="fas fa-heartbeat"></i>
                <span>Encounter</span>
              </router-link>
            </li>
            <li :class="currentPath == 'hospital-reviews' ? 'active' : 'notactive'">
              <router-link to="/hospital/hospital-reviews">
                <i class="fas fa-star"></i>
                <span>Review</span>
              </router-link>
            </li>
            <!-- collapse Sidebar -->

            <li :class="currentPath == 'hospital-reciept' ||
              currentPath == 'new-hospital-reciept' ||
              currentPath == 'edit-hospital-reciept'
              ? 'active'
              : 'notactive'
              ">
              <router-link to="/hospital/hospital-reciept">
                <i class="fas fa-receipt"></i>
                <span>Receipts</span>
              </router-link>
            </li>

            <li :class="currentPath == 'hospital-settings' ? 'active' : 'notactive'">
              <router-link to="/hospital/hospital-settings">
                <i class="fas fa-user-cog"></i>
                <span>Profile</span>
              </router-link>
            </li>
            <!-- <hr> -->
            <li>
              <a href="javascript:void(0);" @click="submit_logout" class="dropdown-item"><i
                  class="fas fa-sign-out-alt"></i><span>Logout</span></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
  <!-- /Profile Sidebar -->
</template>
  
<script>
import { mapActions } from "vuex";
import config from "../../../services/CommonApi";
import CommonApi from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
export default {
  data() {
    return {
      isSidebarOpen: false,
      doctor_profile: {
        gender: "",
      },

      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).username
        : null,
      user_image: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).image
        : null,
      qualification: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).qualification
        : null,

      hospitalName: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).hospital_name
        : '',
      hospitalImage: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).image
        : '',

      hospitalCity: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).city
        : '',

      config: config,
    };
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen; // Toggle the variable
    },

    get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name");
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.doctor_profile.gender = res.data.gender;
        }
      });
    },

    ...mapActions(["signOut"]),

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    navigate(url) {
      this.$router.push(url);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    /* Change Profile Image */
    onFileChange(e, photo) {
      var files = e.target.files;
      if (!files.length) return;
      this.createImage(files[0], photo);
    },

    /* Create Profile Image */
    createImage(file, photo) {
      var reader = new FileReader();
      reader.onload = (e) => {
        if (photo === "main_image") {
          this.update_doctor_profile(file.name, e.target.result);
        }
      };
      reader.readAsDataURL(file);
    },

    /* Upload Image API */
    async update_doctor_profile(filename, upload_image) {
      this.$swal({
        text: "Updating Profile Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.profile_photo_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          const retrievedString = localStorage.getItem("userInfo");
          const parsedObject = JSON.parse(retrievedString);
          parsedObject.image = res.data;
          const strigifiedForStorage = JSON.stringify(parsedObject);
          localStorage.setItem("userInfo", strigifiedForStorage);
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },

    get_doctor_qualification() {
      var qualification_string = [];
      this.qualification.map((data) => {
        qualification_string.push(data.qualification);
      });
      return qualification_string.join(" , ");
    },

    async submit_logout() {
      this.signOut();
      this.$store.dispatch("user/setUserType");
      this.$store.dispatch("user/setUserID");
    },
  },
};
</script>
<style>
/* CSS for desktop view (default) */
.profile-sidebar {
  display: block;
  /* Always open in desktop view */
}

/* Style for hidden sidebar in desktop view */
.icon-style {
  position: absolute;
  left: -9999px;
}

@media (max-width: 768px) {
  .icon-style {
    position: static;
    left: auto;
  }
}

/* CSS for mobile view (screen width less than 768px, adjust as needed) */
@media (max-width: 768px) {
  .mobile-toggle-button-wrapper {
    display: block;
    /* Show the button in mobile view */
  }

  /* Style for hidden sidebar in mobile view */
  .profile-sidebar {
    display: none;
  }

  /* Style for open sidebar in mobile view */
  .profile-sidebar.open {
    display: block;
  }

  /* Style the elements with "icon-style" in mobile view */
  .icon-style {
    /* Add your desired styles here */
  }
}

/* CSS for desktop view (screen width greater than 768px) */
@media (min-width: 768px) {
  .widget-profile {
    display: block;
  }
}

/* CSS for mobile view (screen width up to 768px) */
@media (max-width: 768px) {
  .widget-profile {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/hospital/SideBar.vue